/* eslint-disable comma-dangle */
/* eslint-disable quote-props */
/* eslint-disable quotes */
export default {
	en: {
		"*Allows your data to be saved between devices": "*Allows your data to be saved between devices",
		"*^&$@%": "*^&$@%",
		'4 letters or more': '4 letters or more',
		"About": "About",
		"Aboveboard": "Aboveboard",
		"Achievements": "Achievements",
		"Already have an account?": "Already have an account?",
		"Avatar": "Avatar",
		"Before each hand, players select and pass three cards to a neighbor (varies each round: left, right, across, or no passing).": "Before each hand, players select and pass three cards to a neighbor (varies each round: left, right, across, or no passing).",
		"Bring it on": "Bring it on",
		"Change": "Change",
		"Chat": "Chat",
		"Close Game": "Close Game",
		"Continue": "Continue",
		"CrazyNinja": "CrazyNinja",
		"Create": "Create",
		"Create Account": "Create Account",
		"Create Room": "Create Room",
		"Create or join an existing room": "Create or join an existing room",
		"Deal 13 cards to each player.": "Deal 13 cards to each player.",
		"Delete": "Delete",
		"Delete All": "Delete All",
		"Don't have an account?": "Don't have an account?",
		"Each heart card taken in a trick is worth one penalty point.": "Each heart card taken in a trick is worth one penalty point.",
		"Easy": "Easy",
		"Email Login": "Email Login",
		"Emojis": "Emojis",
		"End of Hand": "End of Hand",
		"Enter": "Enter",
		"Finding server...": "Finding server...",
		"Forgot Password": "Forgot Password",
		"Gameplay": "Gameplay",
		"Gift in crib": "Gift in crib",
		"Good Game": "Good Game",
		"Good run": "Good run",
		"Got lucky": "Got lucky",
		"Had enough?": "Had enough?",
		"Hard": "Hard",
		"Hearts cannot be led until they have been \"broken\" in a previous trick.": "Hearts cannot be led until they have been \"broken\" in a previous trick.",
		"Hello": "Hello",
		"Hi": "Hi",
		"How To Play": "How To Play",
		"How about 2 out of 3?": "How about 2 out of 3?",
		"If successful, they score no penalty points, and each opponent receives 26 penalty points.": "If successful, they score no penalty points, and each opponent receives 26 penalty points.",
		"Impossible": "Impossible",
		"Its real": "Its real",
		"Leaderboard": "Leaderboard",
		"Language": "Language",
		"Level": "Level",
		"Loading": "Loading",
		"Login": "Login",
		"Login as Guest": "Login as Guest",
		"Login to facebook to use your facebook profile": "Login to facebook to use your facebook profile",
		"Login with Email": "Login with Email",
		"Login with Facebook": "Login with Facebook",
		Looking: 'Looking',
		"Maybe next time": "Maybe next time",
		"Medium": "Medium",
		"More Games": "More Games",
		"Name": "Name",
		"Nice Hand": "Nice Hand",
		"Nicely played": "Nicely played",
		"No": "No",
		"No Skunk": "No Skunk",
		"No lurch": "No lurch",
		"No thank you": "No thank you",
		"Nooooooooooo": "Nooooooooooo",
		"OK": "OK",
		"Objective": "Objective",
		"Online": "Online",
		"Oops": "Oops",
		"Ouch": "Ouch",
		"Passing Cards": "Passing Cards",
		"Phrases": "Phrases",
		"Play": "Play",
		"Play Again": "Play Again",
		"Play Again?": "Play Again?",
		"Play a Friend": "Play a Friend",
		"Players aim to avoid taking hearts and the Queen of Spades.": "Players aim to avoid taking hearts and the Queen of Spades.",
		"Players must follow suit if possible; otherwise, they can play any card.": "Players must follow suit if possible; otherwise, they can play any card.",
		"Players often try to \"shoot the moon\" by taking all the hearts and the Queen of Spades in a single hand.": "Players often try to \"shoot the moon\" by taking all the hearts and the Queen of Spades in a single hand.",
		"Please try again later.": "Please try again later.",
		"Private Room": "Private Room",
		"Profile": "Profile",
		"Random": "Random",
		"Rank": "Rank",
		"Rate Game": "Rate Game",
		"Rating": "Rating",
		"Rematch?": "Rematch?",
		"Restore Data": "Restore Data",
		"Reset": "Reset",
		"Reset Stats": "Reset Stats",
		'room name': 'room name',
		"Round Results": "Round Results",
		"Scores are tallied, and the next hand begins with passing cards again.": "Scores are tallied, and the next hand begins with passing cards again.",
		"Scoring": "Scoring",
		"See More Games": "See More Games",
		"Select 3 cards to pass": "Select 3 cards to pass",
		"Select an avatar": "Select an avatar",
		"Send Feedback": "Send Feedback",
		"Setup": "Setup",
		"Share": "Share",
		"Sorry": "Sorry",
		"Statistics": "Statistics",
		"Store": "Store",
		"Strategies": "Strategies",
		"Thank You": "Thank You",
		"Thanks": "Thanks",
		"The Queen of Spades is worth 13 penalty points.": "The Queen of Spades is worth 13 penalty points.",
		"The game continues until a player reaches the predetermined score.": "The game continues until a player reaches the predetermined score.",
		"The game typically continues until a predetermined score is reached, often 50 points.": "The game typically continues until a predetermined score is reached, often 50 points.",
		"The hand continues until all 13 tricks are played.": "The hand continues until all 13 tricks are played.",
		"The main goal of Hearts is to have the lowest score by the end of the game.": "The main goal of Hearts is to have the lowest score by the end of the game.",
		"The player holding the 2 of clubs leads the first trick.": "The player holding the 2 of clubs leads the first trick.",
		"The player with the highest card of the lead suit wins the trick and leads the next one.": "The player with the highest card of the lead suit wins the trick and leads the next one.",
		"The player with the lowest score at the end of the game is the winner.": "The player with the lowest score at the end of the game is the winner.",
		"There is no passing this round": "There is no passing this round",
		"There was an error connecting to the server.": "There was an error connecting to the server.",
		"This will delete all of your data": "This will delete all of your data",
		"Trick-Taking": "Trick-Taking",
		"Use a standard 52-card deck.": "Use a standard 52-card deck.",
		"Well played": "Well played",
		"Winning": "Winning",
		"Yes": "Yes",
		"You're welcome": "You're welcome",
		"across": "across",
		"left": "left",
		"right": "right",
		"wins": "wins",
		"{{pointTotal}} point game": "{{pointTotal}} point game",
		"Join with Code": "Join with Code",
		"Find a Game": "Find a Game",
		"Share this code with a friend to play": "Share this code with a friend to play",
		"Loading...": "Loading...",
		"Start Game?": "Start Game?",
		"Players in room": "Players in room",
		"Player joined!": "Player joined!",
		"You appear to be offline.": "You appear to be offline.",
		"Please check your connection.": "Please check your connection.",
		"Join an existing room with a code": "Join an existing room with a code",
		"Levels": "Levels",
		"New game": "New game",
		"fullVersion =  false": "fullVersion =  false",
		"fullVersion =  true": "fullVersion =  true"
	}
	,
	es: {
		"*Allows your data to be saved between devices": "*Permite guardar tus datos entre dispositivos",
		"*^&$@%": "*^&$@%",
		"About": "Sobre",
		"Aboveboard": "Abiertamente",
		"Achievements": "Logros",
		"Already have an account?": "¿Ya tiene una cuenta?",
		"Avatar": "Avatar",
		"Before each hand, players select and pass three cards to a neighbor (varies each round: left, right, across, or no passing).": "Antes de cada mano, los jugadores seleccionan y pasan tres cartas a un vecino (varía en cada ronda: izquierda, derecha, transversal o sin pase).",
		"Bring it on": "Tráelo",
		"Change": "Cambiar",
		"Chat": "Charlar",
		"Close Game": "Cerrar juego",
		"Continue": "Continuar",
		"CrazyNinja": "NinjaLoco",
		"Create": "Crear",
		"Create Account": "Crear una cuenta",
		"Create Room": "Crear Habitación",
		"Create or join an existing room.": "Crea o únete a una sala existente.",
		"Deal 13 cards to each player.": "Reparte 13 cartas a cada jugador.",
		"Delete": "Eliminar",
		"Delete All": "Eliminar todos",
		"Don't have an account?": "¿No tiene cuenta?",
		"Each heart card taken in a trick is worth one penalty point.": "Cada carta de corazón tomada en un truco vale un punto de penalización.",
		"Easy": "Fácil",
		"Email Login": "Ingresar por correo electrónico",
		"Emojis": "Emojis",
		"End of Hand": "Fin de la mano",
		"Enter": "Entrar",
		"Finding server...": "Buscando servidor...",
		"Forgot Password": "Contraseña olvidada",
		"Gameplay": "Jugabilidad",
		"Gift in crib": "Regalo en la cuna",
		"Good Game": "Buen juego",
		"Good run": "Buena carrera",
		"Got lucky": "Tuve suerte",
		"Had enough?": "¿Has tenido bastante?",
		"Hard": "Difícil",
		"Hearts cannot be led until they have been \"broken\" in a previous trick.": "Los corazones no pueden ser guiados hasta que hayan sido \"rotos\" en un truco previo.",
		"Hello": "Hola",
		"Hi": "Hola",
		"How To Play": "Cómo Jugar",
		"How about 2 out of 3?": "¿Qué tal 2 de 3?",
		"If successful, they score no penalty points, and each opponent receives 26 penalty points.": "Si tienen éxito, no obtienen puntos de penalización y cada oponente recibe 26 puntos de penalización.",
		"Impossible": "Imposible",
		"Its real": "Es real",
		"Leaderboard": "Tabla de clasificación",
		"Language": "Idioma",
		"Level": "Nivel",
		"Loading": "Sobreprima",
		"Login": "Acceso",
		"Login as Guest": "Iniciar sesión como invitado",
		"Login to facebook to use your facebook profile": "Inicia sesión en Facebook para utilizar tu perfil de Facebook",
		"Login with Email": "Iniciar sesión con correo electrónico",
		"Login with Facebook": "Iniciar sesión con Facebook",
		"Maybe next time": "Tal vez la próxima vez",
		"Medium": "Mediano",
		"More Games": "Más juegos",
		"Name": "Nombre",
		"Nice Hand": "Buena mano",
		"Nicely played": "Bien jugado",
		"No": "No",
		"No Skunk": "Sin zorrillo",
		"No lurch": "Sin bandazos",
		"No thank you": "No gracias",
		"Nooooooooooo": "Nooooooooooo",
		"OK": "OK",
		"Objective": "Objetivo",
		"Online": "En línea",
		"Oops": "Ups",
		"Ouch": "Ay",
		"Passing Cards": "Pasar tarjetas",
		"Phrases": "Frases",
		"Play": "Jugar",
		"Play Again": "Juega de nuevo",
		"Play Again?": "¿Volver a jugar?",
		"Play a Friend": "Juega con un amigo",
		"Players aim to avoid taking hearts and the Queen of Spades.": "Los jugadores intentan evitar tomar corazones y la Reina de Picas.",
		"Players must follow suit if possible; otherwise, they can play any card.": "Los jugadores deben seguir su ejemplo si es posible; de lo contrario, pueden jugar cualquier carta.",
		"Players often try to \"shoot the moon\" by taking all the hearts and the Queen of Spades in a single hand.": "Los jugadores a menudo intentan \"disparar a la luna\" tomando todos los corazones y la Reina de Picas en una sola mano.",
		"Private Room": "Habitación privada",
		"Profile": "Perfil",
		"Random": "Al azar",
		"Rank": "Rango",
		"Rate Game": "Califica El Juego",
		"Rating": "Clasificación",
		"Rematch?": "¿Revancha?",
		"Restore Data": "Restaurar datos",
		"Reset": "Restablecer",
		"Reset Stats": "Restablecer estadísticas",
		"Round Results": "Resultados",
		"Scores are tallied, and the next hand begins with passing cards again.": "Se cuentan las puntuaciones y la siguiente mano comienza nuevamente pasando cartas.",
		"Scoring": "Marcador",
		"See More Games": "Ver más juegos",
		"Select 3 cards to pass": "Selecciona 3 cartas para pasar",
		"Select an avatar": "Selecciona un avatar",
		"Send Feedback": "Comentarios",
		"Setup": "Configurar",
		"Share": "Compartir",
		"Sorry": "Lo siento",
		"Statistics": "Estadísticas",
		"Store": "Tienda",
		"Strategies": "Estrategias",
		"Thank You": "Thank You",
		"Thanks": "Gracias",
		"The Queen of Spades is worth 13 penalty points.": "La Reina de Picas vale 13 puntos de penalización.",
		"The game continues until a player reaches the predetermined score.": "El juego continúa hasta que un jugador alcanza la puntuación predeterminada.",
		"The game typically continues until a predetermined score is reached, often 50 points.": "El juego normalmente continúa hasta que se alcanza una puntuación predeterminada, a menudo 50 puntos.",
		"The hand continues until all 13 tricks are played.": "La mano continúa hasta que se juegan las 13 bazas.",
		"The main goal of Hearts is to have the lowest score by the end of the game.": "El objetivo principal de Hearts es tener la puntuación más baja al final del juego.",
		"The player holding the 2 of clubs leads the first trick.": "El jugador que tiene el 2 de tréboles lidera la primera baza.",
		"The player with the highest card of the lead suit wins the trick and leads the next one.": "El jugador con la carta más alta del palo principal gana la baza y lidera la siguiente.",
		"The player with the lowest score at the end of the game is the winner.": "El jugador con la puntuación más baja al final del juego es el ganador.",
		"There is no passing this round": "No se puede pasar esta ronda",
		"This will delete all of your data": "Esto borrará todos tus datos",
		"Trick-Taking": "Tomar Trucos",
		"Use a standard 52-card deck.": "Utilice una baraja estándar de 52 cartas.",
		"Well played": "Bien jugado",
		"Winning": "Victorioso",
		"Yes": "Sí",
		"You're welcome": "De nada",
		"across": "al otro lado",
		"left": "a la izquierda",
		"right": "a la derecha",
		"wins": "gana",
		"{{pointTotal}} point game": "Juego de {{pointTotal}} puntos",
		"fullVersion =  false": "fullVersion =  false",
		"fullVersion =  true": "fullVersion =  true"
	}
	,
	fr: {
		"*Allows your data to be saved between devices": "*Permet à vos données d'être enregistrées entre les appareils",
		"*^&$@%": "*^&$@%",
		"Aboveboard": "Honnête",
		"Achievements": "Succès",
		"Already have an account?": "Vous avez déjà un compte?",
		"Avatar": "Avatar",
		"Bring it on": "Allez",
		"Change": "Changer",
		"Chat": "Bavarder",
		"Close Game": "Match Serré",
		"Continue": "Continuer",
		"CrazyNinja": "CrazyNinja",
		"Create": "Créer",
		"Create Account": "Créer un compte",
		"Create Room": "Créer une chambre",
		"Create or join an existing room.": "Créez ou rejoignez une salle existante.",
		"Delete": "Effacer",
		"Delete All": "Supprimer tout",
		"Don't have an account?": "Vous n'avez pas de compte?",
		"Easy": "Facile",
		"Email Login": "Connectez-vous e-mail",
		"Emojis": "Emojis",
		"Enter": "Entrer",
		"Finding server...": "Trouver un serveur...",
		"Forgot Password": "Mot de passe oublié",
		"Gift in crib": "Cadeau dans le crible",
		"Good Game": "Bonne partie",
		"Good run": "Belle suite",
		"Got lucky": "J'ai eu de la chance",
		"Had enough?": "Tu en as assez?",
		"Hard": "Difficile",
		"Hello": "Allô",
		"Hi": "Bonjour",
		"How about 2 out of 3?": "Un 2 de 3?",
		"Impossible": "Impossible",
		"Its real": "C'est réel",
		"Language": "La langue",
		"Leaderboard": "Classement",
		"Level": "Niveaux",
		"Login": "Login",
		"Login as Guest": "Se connecter en tant qu'invité",
		"Login to facebook to use your facebook profile": "Connectez-vous à Facebook pour utiliser votre profil Facebook",
		"Login with Email": "Connectez-vous e-mail",
		"Login with Email (Full)": "Connectez-vous avec e-mail",
		"Login with Facebook": "Connectez-vous Facebook",
		"Login with Facebook (Full)": "Connectez-vous avec Facebook",
		"Maybe next time": "Peut-être la prochaine fois",
		"Medium": "Médium",
		"More Games": "Plus de jeux",
		"Name": "Nom",
		"Nice Hand": "Belle main",
		"Nicely played": "Bien joué",
		"No": "Non",
		"No Skunk": "Pas de skunk",
		"No lurch": "Pas de problème",
		"No thank you": "Non, merci",
		"Nooooooooooo": "Nonnnn!",
		"OK": "OK",
		"Online": "En ligne",
		"Oops": "Oups!",
		"Ouch": "Aie",
		"Phrases": "Phrases",
		"Play": "Jouer",
		"Play Again": "Une autre partie",
		"Play Again?": "Une autre partie?",
		"Play a Friend": "Défier un ami",
		"Private Room": "Chambre privée",
		"Profile": "Profile",
		"Random": "Aléatoire",
		"Rank": "Rang",
		"Rating": "Note",
		"Rematch?": "Rematch?",
		"Restore Data": "Réinitialiser le data",
		"Reset": "Réinitialiser",
		"Reset Stats": "Réinitialiser les statistiques",
		"Round Results": "Résultats du tour",
		"Select 3 cards to pass": "Sélectionnez 3 cartes pour passer",
		"Select an avatar": "Sélectionnez un avatar",
		"Sorry": "Désolé",
		"Statistics": "Statistiques",
		"Thank You": "Merci à toi",
		"Thanks": "Merci",
		"There is no passing this round": "Il n'y a pas de passe-droit pour ce tour",
		"This will delete all of your data": "Cela supprimera toutes vos données",
		"Type a message": "Tapez un message",
		"Well played": "Bien joué",
		"Yes": "Oui",
		"You": "Vous",
		"You Win": "Vous gagnez!",
		"You're welcome": "De rien",
		"across": "de l'autre",
		"left": "à gauche",
		"right": "à droite",
		"wins": "gagne",
		"{{pointTotal}} point game": "Match à {{pointTotal}} points",
		"fullVersion =  false": "fullVersion =  false",
		"fullVersion =  true": "fullVersion =  true"
	}
	,
};
